import { collection, getDocs, getFirestore } from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { DBCollection } from '@/lib/utils/constants-shared';
import { fetchCollectionFromStorage } from '@/lib/utils/storage-bulk-data';
import type { FirebaseStorage } from 'firebase/storage';

/**
 * Fetch all historical events from Firestore
 */
export async function fetchHistoricalEventsFromDB(storage?: FirebaseStorage): Promise<HistoricalEvent[]> {
    async function fallback() {
        const db = getFirestore(getApp());
        const historicalEventsCollection = collection(db, DBCollection.historicalEvents);
        const snapshot = await getDocs(historicalEventsCollection);

        return snapshot.docs.map(doc => {
            const data = doc.data() as FirebaseHistoricalEvent;
            return {
                id: doc.id,
                ...data,
                createdAt: data.createdAt?.toDate?.()?.toISOString() || new Date().toISOString()
            } as HistoricalEvent;
        });
    }

    if (storage) {
        return await fetchCollectionFromStorage<HistoricalEvent>(
            storage,
            `bulk-data/${DBCollection.historicalEvents}.json`,
            fallback
        );
    }

    return await fallback();
}

